import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useDeprecatedPropsWarning } from '@nerdwallet/deprecate';
import MarketplaceApplyNow, { APPLY_NOW_LINK_TYPES, LINK_TYPES } from '@nerdwallet/react-marketplace-apply-now';
import MarketplaceStarRating from '@nerdwallet/react-marketplace-star-rating';
import { Heading } from '@nerdwallet/currency';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { TRK_PRODUCT_LOCATION, COMPONENT_ANALYTICS_NAME } from './lib/constants';
import { buildTrkSectionCategory, getMonetizable, sanitizeNode } from './lib/utils';
import styles from './marketplace-product-card.module.less';

var ProductCardHeader = function ProductCardHeader(_ref) {
  var analytics = _ref.analytics,
      className = _ref.className,
      ctaHref = _ref.ctaHref,
      displayPage = _ref.displayPage,
      enableAnalytics = _ref.enableAnalytics,
      heading = _ref.heading,
      marketplaceEntity = _ref.marketplaceEntity,
      omitCta = _ref.omitCta,
      omitRating = _ref.omitRating,
      omitRatingTextHref = _ref.omitRatingTextHref,
      productType = _ref.productType,
      reviewLinkHref = _ref.reviewLinkHref,
      shouldLogImpression = _ref.shouldLogImpression,
      starRating = _ref.starRating,
      taxonomy = _ref.taxonomy,
      trkPageType = _ref.trkPageType,
      trkProductPosition = _ref.trkProductPosition,
      trkSectionCategory = _ref.trkSectionCategory;
  var impressionContext = useContext(ImpressionContext);
  useDeprecatedPropsWarning({
    component: 'ProductCardHeader',
    deprecatedProps: [{
      version: '6.9.0',
      deprecated: 'enableAnalytics',
      migration: 'Use analytics instead.'
    }],
    props: {
      enableAnalytics: enableAnalytics
    }
  });
  var productCardHeading = /*#__PURE__*/React.createElement(Heading, {
    color: "neutral-darkest",
    className: styles.heading,
    level: "2",
    size: "3"
  }, sanitizeNode(heading));
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, omitCta ? productCardHeading : /*#__PURE__*/React.createElement(MarketplaceApplyNow, {
    className: styles.headingLink,
    id: "".concat(TRK_PRODUCT_LOCATION, "__product-name-").concat(trkProductPosition),
    impressionId: impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId,
    link: ctaHref,
    linkType: APPLY_NOW_LINK_TYPES.productName,
    marketplaceEntity: marketplaceEntity,
    monetizable: getMonetizable(marketplaceEntity),
    productLocation: TRK_PRODUCT_LOCATION,
    productPosition: trkProductPosition,
    reviewLink: reviewLinkHref,
    sectionName: (analytics === null || analytics === void 0 ? void 0 : analytics.sectionName) || COMPONENT_ANALYTICS_NAME,
    shouldLogImpression: shouldLogImpression,
    trkPageType: trkPageType,
    trkSectionCategory: buildTrkSectionCategory(trkSectionCategory, 'productName'),
    trkTaxonomy: taxonomy,
    type: LINK_TYPES.LINK // BNK specific props.
    ,
    displayPage: displayPage,
    disableBankCtaAnnotation: true
  }, productCardHeading), !omitRating && /*#__PURE__*/React.createElement(MarketplaceStarRating, {
    analytics: analytics,
    className: styles.starRatingContainer,
    enableAnalytics: enableAnalytics,
    marketplaceEntity: marketplaceEntity,
    omitRatingTextHref: omitRatingTextHref,
    productType: productType,
    ratingTextHref: reviewLinkHref,
    starRating: starRating,
    trkLocation: TRK_PRODUCT_LOCATION // TODO stop passing this through
    ,
    trkPageType: trkPageType,
    trkTaxonomy: taxonomy
  }));
};

ProductCardHeader.propTypes = {
  analytics: PropTypes.shape({
    entityName: PropTypes.string,
    sectionName: PropTypes.string
  }),
  className: PropTypes.string,
  ctaHref: PropTypes.string,
  enableAnalytics: PropTypes.bool,
  heading: PropTypes.node.isRequired,
  marketplaceEntity: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  omitCta: PropTypes.bool,
  omitRating: PropTypes.bool,
  omitRatingTextHref: PropTypes.bool,
  productType: PropTypes.string,
  reviewLinkHref: PropTypes.string,
  shouldLogImpression: PropTypes.bool,
  starRating: PropTypes.number,
  taxonomy: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types
  trkPageType: PropTypes.string,
  trkProductPosition: PropTypes.number,
  trkSectionCategory: PropTypes.string,
  // BNK specific props.
  displayPage: PropTypes.string
};
ProductCardHeader.defaultProps = {
  analytics: {},
  omitRating: false,
  omitRatingTextHref: false,
  // BNK specific props.
  displayPage: ''
};
export default ProductCardHeader;